import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, Checkbox, ListItemText, Grid, TextField } from '@mui/material';
import { TextFieldContainer, FormControlStyled, SelectStyled } from '../newFormTemplateStyles';
import { formatPriceIL } from '../../../../pages/plagins/data/commponentOptions';

const MultiSelectComponent = ({ field, value = [], handleChange, error, options, setOptions }) => {
  const [customLabel, setCustomLabel] = useState('');
  const [customPrice, setCustomPrice] = useState(0);
  const [namesOptionsCustom, setNamesOptionsCustom] = useState([]);

  useEffect(() => {
    const tempOptions = [];
    options.forEach(option => {
      tempOptions.push(option.value);
    });
    setNamesOptionsCustom(tempOptions);
  }, [options]);

  const isDisabled = field.disabled || field.lock;

  // פונקציה לעדכון הסטייט הפנימי עבור לייבל ומחיר
  const handleCustomChange = (event) => {
    const { value } = event.target;

    if (event.target.name === 'label') {
      setCustomLabel(value);  // עדכון הלייבל
      const updatedOptions = options.map((option) =>
        option.isCustom ? { ...option, label: value, price: customPrice } : option
      );
      setOptions(field.name, updatedOptions); 
    } else if (event.target.name === 'price') {
      setCustomPrice(value);  // עדכון המחיר
      const updatedOptions = options.map((option) =>
        option.isCustom ? { ...option, label: customLabel, price: value } : option
      );
      setOptions(field.name, updatedOptions); 
    }
  };

  // פונקציה לבדיקת לחיצה על הצ׳קבוקס ולהוסיף/להסיר את האופציה 'custom'
  const handleCustomCheckboxChange = (event, selectedValue) => {
    event.stopPropagation(); // מונע מה-MenuItem להשתלט על האירוע

    const isChecked = value.includes(selectedValue);
    const newValue = isChecked
      ? value.filter(v => v !== selectedValue) // מסיר את ה-'custom' אם הוא כבר נבחר
      : [...value, selectedValue]; // מוסיף את ה-'custom' אם לא נבחר

    handleChange({
      target: {
        name: field.name,
        value: typeof newValue === 'string' ? newValue.split(',') : newValue,
      },
    });
  };

  // פונקציה לטיפול בבחירת אופציה רגילה או מותאמת אישית
  const handleSelectChange = (event) => {
    const {
      target: { value: selectedValue },
    } = event;

    handleChange({
      target: {
        name: field.name,
        value: typeof selectedValue === 'string' ? selectedValue.split(',') : selectedValue,
      },
    });
  };

  return (
    <TextFieldContainer>
      <FormControlStyled fullWidth error={!!error}>
        <InputLabel>{field.label}</InputLabel>
        <SelectStyled
          name={field.name}
          label={field.label}
          value={value || []}
          onChange={handleSelectChange}
          disabled={isDisabled}
          multiple
          renderValue={(selected) => {
            
            const selectedArray = Array.isArray(selected) ? selected : [selected];

            return selectedArray
            .map((selectedValue) => {
              const selectedOption = options
                      ?.find((option) => {
                        return option.value === selectedValue
                      })
                return selectedOption ? selectedOption.label : selectedValue;
              })
              .join(', ');
          }}
        >
          {options?.length && options?.length > 0
            ? options.map((option, index) => {
              if (option.isCustom) {
                return (
                  <MenuItem key={`${option.value}-${index}`} value={'custom'}>
                    <Checkbox 
                      checked={Array.isArray(value) && value.indexOf('custom') > -1}
                      onClick={(e) => handleCustomCheckboxChange(e, 'custom')} // טיפול בבחירת השדה המותאם אישית
                    />
                    <TextField
                      name="label"
                      label="לייבל מותאם"
                      value={customLabel}
                      onChange={handleCustomChange}
                      variant="outlined"
                      onClick={(e) => e.stopPropagation()} // מונע קליק נוסף מ-MenuItem
                    />
                    <TextField
                      name="price"
                      label="מחיר מותאם"
                      type="number"
                      value={customPrice}
                      onChange={handleCustomChange}
                      variant="outlined"
                      sx={{ marginLeft: 2 }}
                      onClick={(e) => e.stopPropagation()} // מונע קליק נוסף מ-MenuItem
                    />
                  </MenuItem>
                );
              } else {
                return (
                  <MenuItem key={`${option.value}-${index}`} value={option.value}>
                    <Checkbox checked={Array.isArray(value) && value.indexOf(option.value) > -1} />
                    <Grid container justifyContent="space-between">
                      <Grid item>
                        <ListItemText primary={option.label} />
                      </Grid>
                      <Grid item>
                        <ListItemText primary={formatPriceIL(option.price)} />
                      </Grid>
                    </Grid>
                  </MenuItem>
                );
              }
            })
            : null}
        </SelectStyled>
        {error && (
          <FormHelperText sx={{ color: 'red' }}>
            {error}
          </FormHelperText>
        )}
      </FormControlStyled>
    </TextFieldContainer>
  );
};

export default MultiSelectComponent;
